var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_menu"},_vm._l((_vm.menus),function(menu){return _c('span',{key:menu.label},[_c('FooterMenu',{attrs:{"url":menu.url,"image":menu.image,"label":menu.label},on:{"handleClick":_vm.handleClick}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }